import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import map from "lodash/map"
import pickBy from "lodash/pickBy"
import { normalizeResponse } from "common/api/normalizer"
import { isNullOrUndefined } from "common/utils/type"
import { get as getCookie } from "utils/cookie"

export function customParamsSerializer(params) {
  const cleanedParams = pickBy(params, (v) => !isNullOrUndefined(v))
  const finalParams = map(cleanedParams, (value, key) => {
    if (Array.isArray(value)) {
      return value.map((v) => `${key}[]=${v}`).join("&")
    } else {
      return `${key}=${value}`
    }
  }).join("&")
  return finalParams
}

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.NEXT_PUBLIC_API_URL,
  paramsSerializer: customParamsSerializer,
  prepareHeaders: (headers) => {
    // Only set Content-Type if it hasn't been set already
    if (!headers.has("Content-Type")) {
      headers.set("Content-Type", "application/json")
    }

    const jwt = window.__AUTH_TOKEN__
    if (jwt) {
      headers.set("X-User-Token", jwt)
    }
    const accessToken = getCookie("access_token")
    if (accessToken) {
      headers.set("Authorization", `Bearer ${accessToken}`)
    }
    return headers
  },
})

const baseService = createApi({
  reducerPath: "companionApi",
  tagTypes: ["UserData", "NotesData", "CandiatesData", "UserTeamsData", "AssignmentChat"],
  baseQuery: async (...args) => {
    try {
      const response = await baseQuery(...args)

      const { normaliseResponse = true } = args[0]

      if (normaliseResponse && response.meta?.response?.ok && response.data?.data) {
        return {
          ...response,
          data: normalizeResponse(response.data),
        }
      } else {
        return response
      }
    } catch (error) {
      console.error("Error in baseQuery:", error)
      return { error: { status: "CUSTOM_ERROR", error: String(error) } }
    }
  },
  endpoints: () => ({}),
})

export const {
  reducer,
  middleware,
  reducerPath,
  util: { invalidateTags },
} = baseService

export default baseService
